module.exports = __webpack_public_path__ + "static/Test-bd09a4497a5bd84767e41a8a117b3ecf.svg";